import { Overlay, Tooltip } from 'react-bootstrap';
import { WarningAmber, CheckCircleOutline, ErrorOutline, InfoOutlined } from "@mui/icons-material";

const StatusOverlay = ({ message, placement = "bottom", show, target, status = "default", arrowMargin = "6px" }) => {
  
  const statusIcon = () => {
    switch (status) {
      case "success":
        return (
          <CheckCircleOutline fontSize="small" style={{marginRight: "2px"}}></CheckCircleOutline>
        );
      
      case "warning":
        return (
          <WarningAmber fontSize="small" style={{marginRight: "2px"}}></WarningAmber>
        );
      
      case "error":
        return (
          <ErrorOutline fontSize="small" style={{marginRight: "2px"}}></ErrorOutline>
        );
      
      case "info":
        return (
          <InfoOutlined fontSize="small" style={{marginRight: "2px"}}></InfoOutlined>
        );
      
      default:
        return;
    }
  }
  
  const tooltipContent = () => {
    switch (placement) {
      case "right":
        return(
          <Tooltip className={`status-overlay--${status}`} style={{ marginLeft: arrowMargin }}>
            {statusIcon()}
            {message}
          </Tooltip>
        );
      
      case "top":
        return(
          <Tooltip className={`status-overlay--${status}`} style={{ marginBottom: arrowMargin }}>
            {statusIcon()}
            {message}
          </Tooltip>
        );
      
      case "left":
        return(
          <Tooltip className={`status-overlay--${status}`} style={{ marginRight: arrowMargin }}>
            {statusIcon()}
            {message}
          </Tooltip>
        );
      
      default:
        return(
          <Tooltip className={`status-overlay--${status}`} style={{ marginTop: arrowMargin }}>
            {statusIcon()}
            {message}
          </Tooltip>
        );
    }
  }
  
  return (
    <Overlay target={target} show={show} placement={placement} >
      {tooltipContent()}
    </Overlay>
  );
};

export default StatusOverlay;

